import { render, staticRenderFns } from "./BrandAndCatagoryView.vue?vue&type=template&id=3c542ba0&"
import script from "./BrandAndCatagoryView.vue?vue&type=script&lang=js&"
export * from "./BrandAndCatagoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports